var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { CourseRow } from './CourseRow';
import styled from 'styled-components';
import { TABLE_HEAD_ROW, TABLE_CELLS, TABLE_HEAD_CELL, TABLE, COURSE_TABLE } from '../../classConstants';
import { getClassName } from '../../helpers';
import { Table } from '../Table';
var courseFactory = function () {
    var Rows = function (_a) {
        var records = _a.records, columnHeaders = _a.columnHeaders;
        var rows = records
            .map(function (datum, index) { return React.createElement(CourseRow, { key: datum.id + '' + index, columnHeaders: columnHeaders, data: datum }); })
            .filter(Boolean);
        return React.createElement("tbody", null, rows);
    };
    var ColGroup = function (props) {
        if (!props.shouldRender)
            return null;
        return (React.createElement("colgroup", null, props.columnHeaders.map(function (_a, i) {
            var key = _a.key;
            return (React.createElement("col", { key: key, className: "ws-colgroup-col-" + key, width: props.widthRef[i] }));
        })));
    };
    var Headers = function (_a) {
        var columnHeaders = _a.columnHeaders, widthRef = _a.widthRef;
        var setHeaderWidth = function (index, width) {
            widthRef.current[index] = width;
        };
        var headers = columnHeaders.map(function (_a, i) {
            var label = _a.label, key = _a.key;
            return (React.createElement("th", { key: key, className: getClassName(TABLE_HEAD_CELL, TABLE_CELLS[key]), ref: function (node) { var _a; setHeaderWidth(i, (_a = node === null || node === void 0 ? void 0 : node.clientWidth) !== null && _a !== void 0 ? _a : 0); } }, label));
        });
        return (React.createElement("thead", null,
            React.createElement("tr", { className: TABLE_HEAD_ROW }, headers)));
    };
    var CourseTable = function (props) {
        var className = props.className, columnHeaders = props.columnHeaders;
        var widthRef = useRef([]);
        var _a = useState([]), allWidths = _a[0], setWidths = _a[1];
        var headers = React.createElement(Headers, { widthRef: widthRef, columnHeaders: columnHeaders });
        var rows = React.createElement(Rows, { columnHeaders: columnHeaders, records: props.records });
        var colGroups = React.createElement(ColGroup, { widthRef: allWidths, shouldRender: !!widthRef.current.length, columnHeaders: columnHeaders });
        var tableClass = getClassName(className || '', TABLE);
        widthRef.current = useMemo(function () { return []; }, [props.records]);
        useLayoutEffect(function () {
            setWidths(widthRef.current.map(function (x) { return x + "px"; }));
        }, [props.records]);
        return (React.createElement(OverflowScrollDiv, { className: COURSE_TABLE },
            React.createElement(Table, { className: tableClass },
                colGroups,
                headers,
                rows)));
    };
    var OverflowScrollDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        overflow-x: auto;\n        max-width: 100%;\n    "], ["\n        overflow-x: auto;\n        max-width: 100%;\n    "])));
    return styled(CourseTable)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        td,\n        th {\n            &:not(:last-child) {\n                text-align: left;\n            }\n        }\n        .", " {\n            text-align: right;\n        }\n    "], ["\n        td,\n        th {\n            &:not(:last-child) {\n                text-align: left;\n            }\n        }\n        .", " {\n            text-align: right;\n        }\n    "])), TABLE_CELLS.booklink);
};
export var CourseTable = courseFactory();
var templateObject_1, templateObject_2;
